import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";

import BaseEntity from "./BaseEntity";
import Soal from "./Soal";

@inheritSerialization(BaseEntity)
export default class AspekBankSoal extends BaseEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public pendidikan: string = "";

    @serialize
    @deserializeAs(Soal)
    public soals: Array<Soal> = [];

}